import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomSelect from "../components/CustomSelect";
import { ContenidoFiltroXs } from '../components/ContenidoFiltroXs';
import { ContenidoFiltro } from '../components/ContenidoFiltro';
import { CiGrid41 } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";
import { CiBoxList } from "react-icons/ci";
import { Grilla } from '../components/Grilla';
import { List } from '../components/List';
import { getCategorias, getProductosByCategoria, getAllProductos, getProductosFiltrados } from '../../actions/home';
import { Pagination } from '../components/Pagination';
import { BreadCrumb } from '../components/BreadCrumb';
  
export const CatalogoProducto = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [view, setView] = useState('grid');
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCategoryDescription, setSelectedCategoryDescription] = useState('');
  const [productos, setProductos] = useState([]);
  const [totalProductos, setTotalProductos] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState('default');
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  // const [limit, setLimit] =  useState(10);

  const categoriaCodigo = queryParams.get('categoria') || '';
  const marcaId = queryParams.get('marca') || '';
  const modeloprocesadorId = queryParams.get('modeloprocesador') || '';
  const ramId = queryParams.get('ram') || '';
  const almacenamientoId = queryParams.get('almacenamiento') || '';
  const graficosId = queryParams.get('graficos') || '';
  const precioMin = queryParams.get('precioMin');
  const precioMax = queryParams.get('precioMax');

  // const categoriaDescripcion = queryParams.get('categoriaDescripcion') || ''; // Para obtener descripcion de la categoría
  const limit = parseInt(queryParams.get('limit'), 10) || 10;
  const page = parseInt(queryParams.get('page'), 10) || 1;
  const sortQuery = queryParams.get('sort') || 'default'

  useEffect(() => {
    if (sortQuery !== sortOrder) {
      setSortOrder(sortQuery)
    }
  }, [sortQuery])

  // const calcularLimit = () => {
  //   const width = window.innerWidth;

  //   if (width >= 1440) {
  //     setLimit(16);
  //   } else if (width >= 1024) {
  //     setLimit(12);
  //   } else {
  //     setLimit(10);
  //   }
  // };

  // useEffect(() => {
  //   calcularLimit();
  //   window.addEventListener("resize", calcularLimit);

  //   return () => {
  //     window.removeEventListener("resize", calcularLimit);
  //   };
  // }, []);

  const categoriaDescripcion = (() => {
    if (selectedCategory && categories.length > 0) {
      const cat = categories.find(c => c.categoriaCodigo === selectedCategory);
      return cat ? cat.categoriaDescripcion : '';
    }
    return '';
  })();


  // Cargar las categorías
  useEffect(() => {
    const loadCategories = async () => {
      setLoading(true);
      try {
        const result = await getCategorias();
        setCategories(result);
        if (categoriaCodigo) {
          setSelectedCategory(categoriaCodigo);
          setSelectedCategoryDescription(categoriaDescripcion); // Asignar la descripción desde la URL
        }
      } catch (error) {
        setError(error.message);
      }
    };

    loadCategories();
  }, [categoriaCodigo, categoriaDescripcion]);


  // Cargar los productos
  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      setProductos([]); 
      setTotalProductos(0); 
      try {
        let result
        if (marcaId || modeloprocesadorId || almacenamientoId || ramId || graficosId || precioMin && precioMax) {
          result = await getProductosFiltrados(
            categoriaCodigo,
            limit,
            page,
            marcaId,
            modeloprocesadorId,
            almacenamientoId,
            ramId,
            graficosId,
            precioMin,
            precioMax,
          )
        } else if (categoriaCodigo) {
          result = await getProductosByCategoria(categoriaCodigo, limit, page, sortOrder);
        } else {
          result = await getAllProductos(limit, page, sortOrder);
        }

        setProductos(result.productos || []);
        setTotalProductos(result.total || 0);

      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [location.search]);


  // Función para cambiar la categoría seleccionada
  const handleCategoryChange = (option) => {
    setSelectedCategory(option.value);
    setSelectedCategoryDescription(option.label); // También cambiar la descripción seleccionada
    navigate(`/catalogo-producto?categoria=${option.value}&categoriaDescripcion=${option.label}&limit=${limit}&page=1&sort=${sortOrder}`);
  };

  // Función para cambiar la página
  const handlePageChange = (newPage) => {
    navigate(`/catalogo-producto?categoria=${selectedCategory}&categoriaDescripcion=${selectedCategoryDescription}&limit=${limit}&page=${newPage}&sort=${sortOrder}`);
  };


  const handleSortChange = (option) => {
    setSortOrder(option.value);
    navigate(`/catalogo-producto?categoria=${selectedCategory}&categoriaDescripcion=${selectedCategoryDescription}&limit=${limit}&page=1&sort=${option.value}`);
  };

  return (
    <div className="producto-page position-relative font-family-montserrat">
      <div className='pad-container-catalogo'>
        <div className="font-family-montserrat font16 breadcrumb-cataproducto ">
          <BreadCrumb
            productoNombre=""
            categoriaDescripcion={selectedCategoryDescription}
            categoriaCodigo={selectedCategory}
          />
        </div>
        <div className="producto-titulo flex-container flex-column">
          <h3 className="font21 txt-titulo txt-semibold">
            {categoriaDescripcion || 'Catálogo de Productos'}
          </h3>
          <div className='txt-center font15 counter-productoxshide'>{totalProductos} Productos encontrados</div>
        </div>
        <div className="producto-header">
          <CustomSelect
            value={sortOrder}
            onChange={handleSortChange}
          />
          <div className='txt-center font15 counter-productosmhide'>{totalProductos} Productos encontrados</div>
          <div className='producto-view flex-container'>
            <div className="producto-view-options align-center flex-container justify-content">
              <button
                id="filtro-btn"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
                className='boton-filtro font-family-montserrat font12v2 font400'>
                <FaFilter className="icon-filter" />
                Filtrar
              </button>
              <ContenidoFiltroXs isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} categoriaCodigo={selectedCategory} />
            </div>
            <div className='shop-view'>
              <h5 className='txt-vistahide'>Vista</h5>
              <CiGrid41 className={`pointer ${view === 'grid' ? 'active' : ''}`} size={22} onClick={() => setView('grid')} />
              <CiBoxList className={`pointer ${view === 'list' ? 'active' : ''}`} size={22} onClick={() => setView('list')} />
            </div>
          </div>
        </div>

        <div className='contenido-producto'>
          <div className='contenido-filtro'>
            <ContenidoFiltro
              onCloseContenido={() => setIsFilterOpen(false)}
              categoriaCodigo={categoriaCodigo}
            />
          </div>
          {view === 'grid' ? <Grilla productos={productos} /> : <List productos={productos} />}
        </div>
      </div>
      <Pagination
        totalProductos={totalProductos}
        productosPorPagina={limit}
        currentPage={page}
        onPageChange={handlePageChange}
      />
    </div>
  );
};